import React from 'react'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import styles from './index.module.scss'

export const MarketBanner: React.FC = () => {
  const { t } = useTranslation('market_banner')

  return (
    <Link
      href="https://market.belegends.com/"
      passHref={ true }
      target="_blank"
    >
      <div className={ styles.marketBanner__container }>
        <img
          src="/market-logo-black.svg"
          alt="Legend Market logo"
          className={ styles.marketBanner__logo }
        />

        <div className={ styles.marketBanner__message }>
          <p className={ styles.marketBanner__message__title }>
            { t('market_banner_title') }

            <FontAwesomeIcon
              icon={ faArrowUpRight }
              className={ styles.marketBanner__message__title__icon }
            />
          </p>

          <p className={ styles.marketBanner__message__subtitle }>
          { t('market_banner_subtitle') }
          </p>
        </div>
      </div>
    </Link>
  )
}
